import { createApp } from 'vue';
import App           from './components/App.vue';
import store         from './store';


function onReady ()
{

    const login = document.querySelectorAll( '.login-container' );

    if ( login.length === 0 )
    {
        return;
    }


    Array.from( login ).forEach( ( el, i ) =>
    {

        const vueLogin = createApp(App);
        vueLogin
            // .provide( 'reactionsOnly',  'true' === el.dataset.reactionsOnly)
             .provide( 'copydeck',  __copydeck__.login)
            .use( store )
            .mount( el )
    } );
}

onReady();
// document.addEventListener( 'DOMContentLoaded', onReady );

// console.log( 'login.js is ready' );
